<template>
  <div>
    <div class="row">
      <div class="col-lg-12">

        <card card-body-classes="table-full-width">
          <el-table v-if="clarification.clarification_id && clarification.questions.length" :data="clarification.questions">
            <el-table-column
              sortable
              type="index">
            </el-table-column>
            <el-table-column
              min-width="150"
              label="Question"
              property="question"
            >
              <div slot-scope="props">
                <div>
                  <h4>{{props.row.question}}</h4>
                </div>
                <small>
                  By {{props.row.author_question.name}} at {{props.row.created_at}}
                </small>
              </div>
            </el-table-column>
            <el-table-column
              min-width="150"
              label="Answer"
              property="answer"
            >
              <div slot-scope="props">
                <div v-if="!props.row.answer && loggedUser.role === UserRoles.APPLICANT">
                  <base-input>
                    <textarea
                      class="form-control"
                      placeholder="Answer here"
                      v-model="props.row.answer_text"
                    >
                    </textarea>
                  </base-input>
                  <base-button
                    class="mb-1 pull-right"
                    type="info"
                    size="sm"
                    @click="saveAnswer(props.row)"
                  >
                    {{$t('general.submit_answer')}}
                  </base-button>
                </div>
                <div v-else>
                  <div>
                    <h4>{{props.row.answer}}</h4>
                  </div>
                  <small v-if="props.row.author_answer">
                    By {{props.row.author_answer.name}} at {{props.row.answered_at}}
                  </small>
                </div>
              </div>
            </el-table-column>
            <el-table-column
              min-width="150"
              align="right"
              header-align="right"
              label="Attachment"
            >
              <div slot-scope="props">
                <div v-if="props.row.request_file || loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN">
                  <div>
                    <span v-if="props.row.request_file" class="badge badge-warning">{{$t('general.requested_attachment')}}</span>
                  </div>
                  <div>
                    <question-box-file @on-file-update="getClarification(true)" :is-editable="(props.row.request_file === 1 && loggedUser.role === UserRoles.APPLICANT) || (loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN)" :question="props.row" :file-data="props.row.file"></question-box-file>
                  </div>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </card>


        <div class="row" v-if="newQuestion">
          <div class="col-lg-6">
            <base-input>
      <textarea
        class="form-control"
        placeholder="Question here"
        v-model="newQuestion.text"
      >
      </textarea>
            </base-input>
            <base-checkbox name="checkbox" v-model="newQuestion.requestFile">
              {{$t('general.request_attachment')}}
            </base-checkbox>
            <base-button
              class="mb-1 pull-right"
              type="info"
              size="sm"
              @click="saveQuestion"
            >
              {{$t('general.submit_question')}}
            </base-button>
          </div>
        </div>
        <div class="clearfix"></div>
        <base-button v-if="loggedUser.role !== UserRoles.APPLICANT" type="simple" @click="addQuestion" size="sm" class="mt-3 btn-fill pull-left">
          {{$t('general.add_question')}}
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    TimeLine,
    TimeLineItem,
  } from 'src/components';
  import QuestionBoxFile from 'src/components/QuestionBoxFile';
  import {Table, TableColumn} from 'element-ui';
  import {ClarificationService, UserRoles} from "@/services";

  export default {
    name: 'question-box',
    components: {
      TimeLine,
      TimeLineItem,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      QuestionBoxFile
    },
    props: {
      application: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        UserRoles,
        clarification: {},
        questions: [],
        newQuestion: undefined,
        loggedUser: {}
      };
    },
    methods: {
      getDateTime() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        today = mm + '.' + dd + '.' + yyyy;
        return today + ' ' + time;
      },
      async saveQuestion() {
        let vm = this;
        if (vm.newQuestion.text.length > 0) {
          vm.newQuestion.datetime = vm.getDateTime();
          vm.questions.push(vm.newQuestion);

          let loader = vm.$loading.show();
          await ClarificationService.question({
            question: vm.newQuestion.text,
            request_file: vm.newQuestion.requestFile,
            application_id: vm.application.application_id
          }).then(function () {
            vm.newQuestion = undefined;
          })

          await vm.getClarification();
          loader.hide();
        }
      },
      async saveAnswer(question) {
        let vm = this;
        if (question.answer_text && question.answer_text.length > 0) {
          let loader = vm.$loading.show();
          await ClarificationService.answer({
            answer: question.answer_text,
            clarification_question_id: question.clarification_question_id
          })

          await vm.getClarification();
          loader.hide();
        }
      },
      addQuestion() {
        let vm = this;
        if (vm.newQuestion === undefined) {
          vm.newQuestion = {
            text: '',
            answer: '',
            author: vm.loggedUser.name,
            requestFile: false,
          }
        } else {
          vm.newQuestion = undefined;
        }
      },
      async getClarification(showSpinner) {
        let vm = this;
        let loader;
        if (showSpinner) {
          loader = vm.$loading.show();
        }
        await ClarificationService.get(vm.application.application_id).then(function (response) {
          vm.clarification = response.data.data;
        })
        if (showSpinner) {
          loader.hide();
        }
        return;
      }
    },
    watch: {
      questions: {
        handler: function (val) {
          this.$emit('input', val);
        },
        deep: true
      }
    },
    async mounted() {
      let vm = this;
      let loader = vm.$loading.show();
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
      await vm.getClarification();
      loader.hide();
    },
  };
</script>
<style scoped>
  textarea {
    resize: both !important;
    max-height: 100% !important;
  }
</style>
